import { TagSimple } from "@phosphor-icons/react";

interface SecondaryLabelProps {
  item: string;
  onSelect: (value: string) => void;
}

export const SecondaryLabelItem = ({ item, onSelect }: SecondaryLabelProps) => {
  return (
    <button
      onClick={() => onSelect(item)}
      className="w-full text-left p-3 hover:bg-gray-100 rounded-sm border-b border-gray-100 last:border-b-0"
    >
      <div className="flex items-center gap-2">
        <TagSimple size={16} className="text-moss-primary" />
        <span>{item}</span>
      </div>
    </button>
  );
};